/* ==================================================
  c_karte-cart.js — KARTE「カート」イベント（cart）の送信
===================================================*/

/*  TABIO-610。現行サイト（tabio.com/jp）の common.min.js が送信している cart を
    移植したもの。項目名は現行サイトに合わせる。

    現行サイトはカートへの追加・削除の操作ごとに送信し、追加なら added_item_id、
    削除なら deleted_item_id を添える。本実装も同じで、単なるページ表示では送らない。

    【カート操作の経路が2つあることに注意】
    1. Ajax 更新
       商品ページからの追加など。テーマは cart:updated と cart:refresh を投げる。
       SKU 単位の追加（snippets/c_sku-cart-add.liquid）は cart:refresh のみ。
       どちらも detail.cart に /cart.js の内容が載る（載らない呼び出しもある）。
    2. フルリロード
       カートページでの数量変更・削除。イベントは飛ばずページが再読み込みされる。

    2 を取りこぼさないよう、前回のカート内容を sessionStorage に保存しておき、
    ページ読み込み時に Liquid が出力した現在のカート（window.cKarteCart.initialCart）
    と突き合わせる。差分があれば、その場で送信する。

    カテゴリ4項目は /cart.js に含まれないため、Ajax 経路では Liquid が出力した
    商品ハンドルの対応表から引く。フルリロード経路では Liquid が各行に直接
    埋めてくれるのでそのまま使える。引けない場合はその項目を送らない
    （現行サイトも値が無ければ送らない）。 */

(function () {
  'use strict';

  if (window.CKarteCart) return;
  window.CKarteCart = true;

  const STORAGE_KEY = 'c_karte_cart_state';

  const config = window.cKarteCart || {};
  const productMeta = config.productMeta || {};
  const origin = config.origin || window.location.origin;
  const initialCart = config.initialCart || { price: 0, quantity: 0, status: false, lines: [] };

  /* ------------------------------
    保存領域
  ------------------------------*/

  /*  プライベートブラウジング等で sessionStorage が使えない場合もあるため、
      読み書きは常に失敗を許容する。使えないときはフルリロード経路の検出を
      諦めるだけで、Ajax 経路の送信は妨げない。 */
  function readState() {
    try {
      const raw = window.sessionStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (error) {
      return null;
    }
  }

  function writeState() {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ snapshot: snapshot, skus: skuCache }));
    } catch (error) {
      /* 保存できなくても送信自体は継続する */
    }
  }

  /* ------------------------------
    値の組み立て
  ------------------------------*/

  /*  品番は SKU からカラーコード（末尾2桁）を除いた先頭9桁。
      Liquid 側の c_sku-item-code スニペットと同じルール。 */
  function toItemId(sku) {
    if (!sku) return null;
    return sku.length === 11 ? sku.slice(0, 9) : sku;
  }

  /*  Shopify の画像 URL は // 始まりのプロトコル相対で返ることがある。 */
  function toAbsoluteUrl(url) {
    if (!url) return null;
    return url.indexOf('//') === 0 ? 'https:' + url : url;
  }

  /*  現行サイトと同じく、値が無い項目は送らない。 */
  function compact(source) {
    const result = {};
    Object.keys(source).forEach(function (key) {
      const value = source[key];
      if (value === null || value === undefined || value === '') return;
      result[key] = value;
    });
    return result;
  }

  /*  /cart.js の行から送信用の項目を組み立てる（Ajax 経路）。 */
  function buildItemFromCartJs(line) {
    const meta = productMeta[line.handle] || {};
    const itemUrl = origin + '/products/' + line.handle;

    return {
      item_id: toItemId(line.sku),
      name: line.product_title,
      price: line.price / 100,
      quantity: line.quantity,
      item_url: itemUrl,
      item_image_url: toAbsoluteUrl(line.image),
      l_category_name: meta.l_category_name,
      s_category_name: meta.s_category_name,
      l_category_cd: meta.l_category_cd,
      s_category_cd: meta.s_category_cd,
      brand: line.vendor,
      sku_id: line.sku,
      /*  現行サイトは item_url に ?color_code= を付けて SKU 単位の URL にしている。
          Shopify はカラーではなくバリアントで URL が決まるため、/cart.js が返す
          バリアント付き URL をそのまま使う。 */
      sku_url: line.url ? origin + line.url : itemUrl,
      sku_image_url: toAbsoluteUrl(line.image)
    };
  }

  /*  Liquid が出力した行から組み立てる（フルリロード経路）。key は送信しない。 */
  function buildItemFromLiquid(line) {
    const item = Object.assign({}, line);
    delete item.key;
    item.item_image_url = toAbsoluteUrl(item.item_image_url);
    item.sku_image_url = toAbsoluteUrl(item.sku_image_url);
    return item;
  }

  /*  現行サイトは items の各項目を横持ちの配列でも送っている。 */
  const LIST_FIELDS = [
    ['item_ids', 'item_id'],
    ['item_names', 'name'],
    ['item_prices', 'price'],
    ['item_quantities', 'quantity'],
    ['item_urls', 'item_url'],
    ['item_image_urls', 'item_image_url'],
    ['l_category_names', 'l_category_name'],
    ['s_category_names', 's_category_name'],
    ['l_category_cds', 'l_category_cd'],
    ['s_category_cds', 's_category_cd'],
    ['item_brands', 'brand'],
    ['item_sku_ids', 'sku_id'],
    ['item_sku_urls', 'sku_url'],
    ['item_sku_image_urls', 'sku_image_url']
  ];

  /* ------------------------------
    状態
  ------------------------------*/

  const liquidSnapshot = {};
  const liquidSkus = {};
  initialCart.lines.forEach(function (line) {
    liquidSnapshot[line.key] = line.quantity;
    liquidSkus[line.key] = line.sku_id;
  });

  const stored = readState();

  /*  行キー → 数量。差分の基準になる。 */
  let snapshot = stored ? stored.snapshot : liquidSnapshot;

  /*  削除された行はカートから消えて SKU を引けなくなるため保持しておく。 */
  let skuCache = Object.assign({}, stored ? stored.skus : {}, liquidSkus);

  /* ------------------------------
    差分の判定
  ------------------------------*/

  /*  増えた行があれば追加、無ければ減った（消えた）行を削除として扱う。 */
  function detectChange(current) {
    let added = null;
    let deleted = null;

    Object.keys(current).forEach(function (key) {
      if (added) return;
      if (current[key] > (snapshot[key] || 0)) added = key;
    });

    if (!added) {
      Object.keys(snapshot).forEach(function (key) {
        if (deleted) return;
        if ((current[key] || 0) < snapshot[key]) deleted = key;
      });
    }

    return { added: added, deleted: deleted };
  }

  /* ------------------------------
    送信
  ------------------------------*/

  function send(totals, items, current, changedSkus) {
    const change = detectChange(current);

    snapshot = current;
    skuCache = Object.assign({}, skuCache, changedSkus);
    writeState();

    if (!change.added && !change.deleted) return;

    const values = {
      price: totals.price,
      quantity: totals.quantity,
      status: totals.status,
      items: items.map(compact)
    };

    const changedKey = change.added || change.deleted;
    const sku = skuCache[changedKey];
    if (sku) {
      if (change.added) {
        values.added_item_id = toItemId(sku);
        values.added_item_sku_id = sku;
      } else {
        values.deleted_item_id = toItemId(sku);
        values.deleted_item_sku_id = sku;
      }
    }

    LIST_FIELDS.forEach(function (pair) {
      values[pair[0]] = items.map(function (item) {
        return item[pair[1]];
      });
    });

    try {
      krt('send', 'cart', compact(values));
    } catch (error) {
      if ('krt' in window) {
        krt('send', '_error', { message: error.message });
      } else {
        console.warn('[c_karte-cart] tracker was not loaded');
      }
    }
  }

  /* ------------------------------
    経路 1: Ajax 更新
  ------------------------------*/

  const cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function handleCartJs(cart) {
    if (!cart) return;

    const current = {};
    const skus = {};
    (cart.items || []).forEach(function (line) {
      current[line.key] = line.quantity;
      skus[line.key] = line.sku;
    });

    send(
      { price: cart.total_price / 100, quantity: cart.item_count, status: cart.item_count > 0 },
      (cart.items || []).map(buildItemFromCartJs),
      current,
      skus
    );
  }

  /*  テーマ標準は cart:updated と cart:refresh の両方を投げるが、SKU 単位の
      カート追加は cart:refresh しか投げないため両方を購読する。同じ操作で
      二重に発火しても、差分が無ければ送信しないので重複しない。 */
  function onCartEvent(event) {
    const cart = event.detail && event.detail.cart;
    if (cart) {
      handleCartJs(cart);
      return;
    }
    fetch(cartRoot + 'cart.js', { credentials: 'same-origin' })
      .then(function (response) { return response.json(); })
      .then(handleCartJs)
      .catch(function () { /* 取得に失敗しても他の計測は妨げない */ });
  }

  document.documentElement.addEventListener('cart:updated', onCartEvent);
  document.documentElement.addEventListener('cart:refresh', onCartEvent);

  /* ------------------------------
    経路 2: フルリロード
  ------------------------------*/

  /*  保存済みの状態が無い初回表示では差分を取らない（カートの中身をそのまま
      「追加」として誤送信しないため）。状態の保存だけ行う。 */
  if (!stored) {
    snapshot = liquidSnapshot;
    writeState();
  } else {
    send(
      { price: initialCart.price, quantity: initialCart.quantity, status: initialCart.status },
      initialCart.lines.map(buildItemFromLiquid),
      liquidSnapshot,
      liquidSkus
    );
  }
})();
